import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ReactHtmlParser from 'react-html-parser';
import dompurify from 'dompurify';

import {
    currentLanguage,
    Translate
} from "src/shared_modules/i18n";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    //fetchLiveConference,
} from 'src/shared_modules/veu-visitors-core/actions/event';

import 'src/shared_modules/veu-visitors-core/components/popovers/popovers.css';


class PopoverReminderConference extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
      //this.props.fetchLiveConference();
      //console.log("PopoverReminderConference channel: " + JSON.stringify(this.props.event.liveConference));
    }

    clickClose() {
        // TODO bind this on the close button
        this.props.hidePopover("ReminderConference");
    }



    render() {
      if( !this.props.event.channelurl )
          return(null);

      const sanitizer = dompurify.sanitize;

      let currentLangi18n = currentLanguage();

        return (
            <div className="popover reminderOverlay">
                <div className="reminderConference">
                    <h1>{this.props.event.liveConference.title[currentLangi18n.code2]}</h1>
                    <hr />
                    <p>{ReactHtmlParser(sanitizer(this.props.event.liveConference.description[currentLangi18n.code2]))}</p>
                    <a href={this.props.event.channelurl}><i className="material-icons">open_in_new</i> <Translate>popovers.reminder.conference.linktext</Translate></a>
                </div>
            </div>
        );
    }
}

/*
 * ---------------------------------------------------------------------
 * prop Types
 * ---------------------------------------------------------------------
 */
PopoverReminderConference.propTypes = {
    system : PropTypes.object,
    event: PropTypes.object,
};

/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */

const mapStateToProps = ( state, ownProps ) => {
    return {
      system: state.system,
      event: state.event,
    };
};

const mapDispatchToProps = {
    showPopover,
    hidePopover,
    //fetchLiveConference,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(PopoverReminderConference);
